import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../e-met/services/shared.service';
@Component({
    selector: 'app-price-component',
    templateUrl: './price.component.html',
    styleUrls: ['./price.component.scss'],
})
export class PriceComponent implements OnInit {
    @Input() priceObject: any;
    // #FIX - extract emitter payload into an interface
    @Output() dataChanged: EventEmitter<{
        cadId: number;
        paymentMethodId: string;
    }> = new EventEmitter();

    priceTableToggler = true;
    submitted: boolean = false;

    // fg: FormGroup = new FormGroup({
    //     cadId: new FormControl({value: null , validator: Validators.required}),
    //     paymentMethodId: new FormControl({value: null , validator: Validators.required}),
    // });

    @Input() fg: FormGroup;
    constructor(private sharedService: SharedService) {}

    ngOnInit(): void {
        // When data changes emit a new event
        // This way parent component can catch and perform appropriate actions e.g: Redirect user to pay with Viva if Payment Method is Card
        // #TODO - Do not subscribe if form is disabled (in case application is submitted)
        // this.fg.get('cadId').markAsDirty({onlySelf: true})
        // this.fg.valueChanges.subscribe({
        //     next: (value) => {
        //         this.dataChanged.emit(value);
        //         this.sharedService.updatepricingPanelVariable({
        //             cadID: this.fg.get('cadId').value,
        //             paymentMethod: this.fg.get('paymentMethodId').value,
        //         });
        //     },
        // });
        // if (this.priceObject.applicationStatus == 'COMPLETED') {
        //     this.fg.disable();
        // }
    }
    toggleCard() {
        this.priceTableToggler = !this.priceTableToggler;
    }
}
